import React from 'react';

import * as S from './styles';

const Header: React.FC = () => {
  return (
    <S.Container>
      <S.Column className="left">
        <S.Wrapper>
          <S.Headline>
            Se vestir
            <br />
            no inverno
            <br />
            nunca foi
            <br />
            tão divertido
          </S.Headline>
          <S.Subtitle>conteúdo apresentado por mercado livre</S.Subtitle>
          <S.Text>
            <p>
              Se a preguiça domina na hora de <br />
              elaborar um visual para o frio, <br />
              Mercado Livre prova que é possível <br />
              gostar da estação quando <br />o estilo é seu aliado.
            </p>
          </S.Text>
        </S.Wrapper>
      </S.Column>
      <S.Column className="right">
        <S.ModaLivreGif />
      </S.Column>
    </S.Container>
  );
};

export default Header;
